export const FIELD_SIZES = ['sm', 'md', 'lg'];

export const BUTTON_VARIANTS = [
  'primary',
  'secondary',
  'danger',
  'muted',
  'outline',
  'primary-outline',
  'red-outline',
  'blue-outline',
  'green-outline'
];

export const BUTTON_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];

export const BADGE_VARIANTS = ['default', 'primary', 'success', 'warning', 'error', 'info', 'neutral'];

export const NOTIFICATION_VARIANTS = ['info', 'warning', 'error', 'neutral', 'success'];

export const SNACKBAR_VARIANTS = ['success', 'error', 'warning', 'info'];

export const HEADING_LEVELS = [1, 2, 3, 4, 5, 6];

export const MODAL_SIZES = ['sm', 'md', 'lg', 'xl', 'full'];
